module.exports = __webpack_public_path__ + "img/20180120_10.ca743a32.jpeg";